import { useTranslation } from "react-i18next";
import { Icon, useTheme } from "@aigntx/ui";
import type { Locale, ThemeMode } from "@aigntx/ui";
import { endpoints } from "./api";
import { useAuth } from "./auth";
import type { UserSettings } from "./types";

export function ThemeControls() {
  const { theme, setMode, setLocale } = useTheme();
  const { user } = useAuth();
  const { i18n } = useTranslation();

  function persist(patch: Partial<UserSettings>) {
    if (user) void endpoints.saveSettings(patch).catch(() => {});
  }

  function toggleTheme() {
    const next: ThemeMode = theme.mode === "dark" ? "light" : "dark";
    setMode(next);
    persist({ mode: next });
  }

  function toggleLang() {
    const next: Locale = theme.locale === "ar" ? "en" : "ar";
    setLocale(next);
    void i18n.changeLanguage(next);
    persist({ locale: next });
  }

  return (
    <div className="tc">
      <button
        className="tc__btn"
        onClick={toggleTheme}
        title={theme.mode}
        aria-label={theme.mode === "dark" ? "Switch to light" : "Switch to dark"}
      >
        <Icon name={theme.mode === "dark" ? "moon" : "sun"} size={17} />
      </button>
      <button className="tc__btn tc__lang" onClick={toggleLang} aria-label="Toggle language">
        {theme.locale === "ar" ? "ع" : "EN"}
      </button>
    </div>
  );
}
